import { useState, useEffect } from "react";
export function useMediaQuery(query) {
  var _useState = useState(false),
    matches = _useState[0],
    setMatches = _useState[1];
  useEffect(function () {
    // Check if window is defined (SSR safety)
    if (typeof window === "undefined") {
      return;
    }
    var media = window.matchMedia(query);

    // Set initial value
    setMatches(media.matches);

    // Create listener
    var listener = function listener(event) {
      setMatches(event.matches);
    };

    // Modern browsers
    if (media.addEventListener) {
      media.addEventListener("change", listener);
      return function () {
        return media.removeEventListener("change", listener);
      };
    } else {
      // Fallback for older browsers
      media.addListener(listener);
      return function () {
        return media.removeListener(listener);
      };
    }
  }, [query]);
  return matches;
}
export default useMediaQuery;